export default __webpack_public_path__ + "static/water-f58662df09e8a3a1f3d4656aa147cf0a.mp4";